KMVP.deliveryInstructions = {
    bindOpenFormPopupButtons: function () {
        $(document).on('click', '[data-delivery-instructions-form-url]', function () {
            $.ajax({
                url: $(this).data('deliveryInstructionsFormUrl'),
                type: "GET",
                success: function (data, response) {
                    $.colorbox({
                        innerWidth: '1000px',
                        html: data,
                        height: false,
                        scrolling: false,
                        onComplete: KMVP.deliveryInstructions.initFormPopup
                    });
                }
            });
        });
    },
    initFormPopup: function () {
        KMVP.deliveryInstructions.$formPopup = $('.deliveryInstructionsFormPopup');
        with (KMVP.deliveryInstructions) {
            initLifting();
            handleLifting();
            manualHandlingElement.addEventListener('change', handleLifting);
            bindCancelButton();
            bindFormValidation();
            $formPopup.find('form').ajaxForm(function(cartData) {
                ACC.checkoutB2B.refresh(cartData);
                $.colorbox.close();
            });
        }
    },
    initLifting: function(){
        KMVP.deliveryInstructions.manualHandlingElement = document.getElementById('deliveryInstructions.manualHandling');
        KMVP.deliveryInstructions.fltOffloadElement = document.getElementById('deliveryInstructions.fltOffload');
        KMVP.deliveryInstructions.ohcOffloadElement = document.getElementById('deliveryInstructions.ohcOffload');
    },
    handleLifting: function () {
        with (KMVP.deliveryInstructions) {
            if (manualHandlingElement.checked) {
                fltOffloadElement.setAttribute('disabled', 'disabled');
                fltOffloadElement.selectedIndex = 0;
                ohcOffloadElement.setAttribute('disabled', 'disabled');
                ohcOffloadElement.selectedIndex = 0;
            } else {
                fltOffloadElement.removeAttribute('disabled');
                ohcOffloadElement.removeAttribute('disabled');
            }
        }
    },
    bindCancelButton: function(){
        KMVP.deliveryInstructions.$formPopup.find('.js-cancelButton').on('click', function (e) {
            e.preventDefault();
            $.colorbox.close();
        });
    },
    bindFormValidation: function(){
        KMVP.deliveryInstructions.$formPopup.find('button[type=submit]').on('click', function (e) {
            KMVP.deliveryInstructions.$formPopup.find('.inputField').each(function(){
                var $this = $(this);
                $this.val($this.val().trim());
                var $group = $this.closest('.inputGroup');
                var $error = $group.next().find('.js-inputFieldError');
                if($this.val()) {
                    $group.removeClass('error');
                    $error.hide();
                } else {
                    $group.addClass('error');
                    $error.show();
                }
            });
            if(KMVP.deliveryInstructions.$formPopup.find('.inputGroup.error').length){
                e.preventDefault();
                $.colorbox.resize();
            }
        });
    },
    updateActionSection: function(cartData){
        var $nextStepButton = $('.js-delivery-instructions-next-step-button');
        var $placeOrderForm = $('.js-placeOrderForm');
        if($nextStepButton.length) {
            if(cartData.deliveryAddress.deliveryInstructions) {
                $placeOrderForm.show();
                $nextStepButton.hide();
            } else {
                $placeOrderForm.hide();
                $nextStepButton.show();
            }
        } else {
            $placeOrderForm.show();
        }
    }
};

$(document).ready(function () {
    if ($("body").hasClass("page-singleStepCheckoutSummaryPage") || $("body").hasClass("page-contractSingleStepCheckoutSummaryPage")) {
        KMVP.deliveryInstructions.bindOpenFormPopupButtons();
    }
});
